import { render, staticRenderFns } from "./ActivityDetailPanelContentLoadingState.vue?vue&type=template&id=ef180546&scoped=true&"
var script = {}
import style0 from "./ActivityDetailPanelContentLoadingState.vue?vue&type=style&index=0&id=ef180546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef180546",
  null
  
)

export default component.exports